import { render, staticRenderFns } from "./ModalConfirmation.vue?vue&type=template&id=31c1a0a7&scoped=true&"
import script from "./ModalConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ModalConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=31c1a0a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1a0a7",
  null
  
)

export default component.exports